import PageRenderer from "../components/PageRenderer";

const Teilnahmeregeln = () => <PageRenderer pageName="Teilnahmeregeln" analyticsPath="/teilnahmeregeln" />;

export default Teilnahmeregeln;
